import {twMerge} from 'tailwind-merge';
import React, {FC, Fragment, PropsWithChildren} from 'react';

interface ITab {
  id: string;
  label: string;
  disabled?: boolean;
  className?: string;
}

interface ITabsProps {
  tabs: ITab[];
  activeTab: string;
  onSelect: (id: string) => void;
}

const Tab: FC<{activeTab: string; tab: ITab; onSelect: (id: string) => void}> = ({activeTab, tab, onSelect}) => {
  const isActive = activeTab === tab.id;
  return (
    <div
      className={twMerge(
        'tab-bar-item relative font-bold cursor-pointer bg-[#e7e7e7] h-[50px] items-center',
        isActive ? 'text-[#707ae5] bg-white items-center' : '',
        tab.disabled ? 'cursor-default text-gray-300' : '',
        'text-xs tablet:text-sm',
        'px-1 tablet:pr-2 tablet:pl-6 flex flex-1 justify-center',
        tab.className || '',
      )}
      onClick={
        tab.disabled
          ? (e) => {
              e.preventDefault();
            }
          : (e) => {
              e.preventDefault();
              onSelect(tab.id);
            }
      }>
      <svg
        aria-hidden
        xmlns="http://www.w3.org/2000/svg"
        width="19"
        height="50"
        viewBox="0 0 19 50"
        className="absolute top-0 right-[-19px] z-10 pointer-events-none hidden tablet:block">
        <polygon points="0,0 19,25 0,50" fill={isActive ? '#ffffff' : '#e7e7e7'} />
      </svg>
      <span>{tab.label}</span>
    </div>
  );
};

export const BreadcrumbTabs: FC<PropsWithChildren<ITabsProps>> = ({tabs, activeTab, onSelect, children}) => {
  return (
    <div className="flex flex-row tablet:flex-[0_0_50px] flex-1 bg-[#ffffff] items-end drop-shadow text-[#72757d] border-b border-b-[#dddddd]">
      {tabs.map((tab) => (
        <Fragment key={tab.id}>
          <Tab key={tab.id} tab={tab} activeTab={activeTab} onSelect={onSelect} />
        </Fragment>
      ))}

      {children && (
        <>
          <div className="flex flex-1" />
          <div>{children}</div>
        </>
      )}
    </div>
  );
};
